module.exports = __webpack_public_path__ + "static/img/domain-bg.e1f1aa0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/domain-bg.png
// module id = JjBT
// module chunks = 0